import { HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { AuthConfig, OAuthModule, OAuthModuleConfig, OAuthStorage } from 'angular-oauth2-oidc';
import { authConfig } from './auth.config';
import { AuthAutoLoginGuard } from './auth-auto-login.guard';
import { authModuleConfig } from './auth.module.config';
import { AuthService } from './auth.service';

// We need a factory since localStorage is not available at AOT build time
// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function storageFactory(): OAuthStorage {
  return localStorage;
}

@NgModule({
  imports: [
    HttpClientModule,
    OAuthModule.forRoot(),
  ],
  providers: [
    AuthService,
    AuthAutoLoginGuard,
  ],
})
export class AuthCoreModule {
  static forRoot(): ModuleWithProviders<AuthCoreModule> {
    return {
      ngModule: AuthCoreModule,
      providers: [
        { provide: AuthConfig, useValue: authConfig },
        { provide: OAuthModuleConfig, useValue: authModuleConfig },
        { provide: OAuthStorage, useFactory: storageFactory },
      ]
    };
  }

  constructor(@Optional() @SkipSelf() parentModule: AuthCoreModule) {
    if (parentModule) {
      throw new Error('AuthCoreModule is already loaded. Import it in the AppModule only');
    }
  }
}
